module.exports = __webpack_public_path__ + "img/document_hash.e2749fe5.gif";